import { render, staticRenderFns } from "./SalaryStatistics.vue?vue&type=template&id=ff9f3d0c&scoped=true"
import script from "./SalaryStatistics.vue?vue&type=script&lang=js"
export * from "./SalaryStatistics.vue?vue&type=script&lang=js"
import style0 from "./SalaryStatistics.vue?vue&type=style&index=0&id=ff9f3d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9f3d0c",
  null
  
)

export default component.exports